import React, { useState } from 'react';
import { Button, Collapse, Form, Card } from 'react-bootstrap';
export const removeRemarks = (questionText) => {
    // Find the index of "REMARKS=" within the question text
    const remarksIndex = questionText.indexOf("REMARKS=");
    if (remarksIndex !== -1) {
        // If "REMARKS=" is found, remove everything after it
        questionText = questionText.slice(0, remarksIndex);
    }

    // Remove any styling related to "REMARKS="
    questionText = questionText.replace(/style=".*?"/g, '');
    //const updatedQuestionText = questionText.replace('font size="2"', 'font size="4"');
    const updatedQuestionText = questionText.replace(/font\s+size\s*=\s*"\d+"/g, 'font size="20px"');


    return updatedQuestionText;
}
const GradeCheck = ({ ques }) => {
  const [open, setOpen] = useState(false);
  const [marks, setMarks] = useState('');
  const [comments, setComments] = useState('');

  const handleSave = () => {
    setOpen(false); // Close the dropdown after saving
  };

  return (
    <div>
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="grading-form"
        aria-expanded={open}
        style={{width:'140px'}}
      >
        {open ? 'Close' : 'Grade'}
      </Button>
      <Collapse in={open}>
        <div id="grading-form" style={{width: '700px',height:'auto'}}>
          <Card style={{ marginTop: '10px' }}>
            <Card.Body>
              <Form>
                <Form.Group controlId="formMarks">
                  <Form.Label>Marks</Form.Label>
                  <Form.Control
                    type="number"
                    value={ques?.questionresponse_set?.scored_marks} 
                    min="0"
                    step="0.1"
                  />
                </Form.Group>
                <Form.Group controlId="formComments" style={{ marginTop: '10px' }}>
                  <Form.Label>Remarks/Comments</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={ques?.questionresponse_set?.graded ? ques?.questionresponse_set?.remark : "Not yet graded"}
                  />
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </Collapse>
    </div>
  );
};

export default GradeCheck;
